module.exports = __webpack_public_path__ + "static/media/ru.25e1343a.ogg";